const crop_type_list = [    
	"apricot_tree",
	"aubergine",
	"basil",
	"alfalfa",
	"other_fruit_trees",
	"almond_trees",
	"anethum_graveolens",
	"celery",
	"rice",
	"hazelnut_tree",
	"corn",
	"durum_wheat",
	"khorasan_wheat",
	"soft_wheat",
	"swiss_chard",
	"common_marigold",
	"mushrooms",
	"borage",
	"hemp",
	"peanut",
	"camomile",
	"camelina",
	"common_cane",
	"khaki",
	"pumkpin",
	"zucchini",
	"artichoke",
	"chestnut_tree",
	"onions_garlick",
	"chickpea",
	"cherry_tree",
	"oat",
	"clementine",
	"quince_tree",
	"cucumber",
	"cabbage_and_coliflower",
	"colza",
	"coriander",
	"watercress",
	"tail_of_rat",
	"date",
	"lettuce",
	"endive_chicory",
	"erbs",
	"canary_grass",
	"asparagus",
	"aromatic_herbs",
	"woody_aromatiques",
	"spelt",
	"spinach",
	"buckwheat",
	"thyme",
	"moreu",
	"beans",
	"fenugreek",
	"festuca",
	"fig_tree",
	"flowers_and_ornamental",
	"fennel",
	"fruit_trees",
	"green_pea",
	"carob_tree",
	"blueberry",
	"sunflower",
	"redcurrant",
	"lying_fallow",
	"lathyrus_sativus",
	"hyssop",
	"orchard",
	"parsley",
	"kiwi",
	"lavender",
	"hop",
	"lentils",
	"linen",
	"lemons",
	"strawberry",
	"pomegranate_tree",
	"mandarin_tree",
	"marjoram",
	"melon",
	"orange_blossom",
	"mint",
	"mestall",
	"mill",
	"alt_beans_1",
	"blueberrys",
	"chinese_turnip_and_cabbage",
	"nashi",
	"nectarine_tree",
	"medlar",
	"walnut_trees",
	"olive_trees",
	"barley",
	"oregano",
	"pea_and_oat",
	"peas_and_barley",
	"peas",
	"carrot",
	"potato",
	"pepper",
	"pear_trees",
	"pear_apple_tree",
	"hypericum_or_saint_johns_wort",
	"pistachio",
	"bread_poa",
	"grapefruit",
	"apple_trees",
	"peach_trees",
	"peach_nectarine_tree",
	"plum_tree",
	"quinoa",
	"grape",
	"radish",
	"ray_grass",
	"beetroot",
	"rosemary",
	"rye",
	"watermelon",
	"saffron",
	"sajolida",
	"satsuma_tangerine",
	"soy",
	"sorghum",
	"sulla",
	"truffle",
	"tobacco",
	"orange_tree",
	"tomato",
	"clover",
	"sweet_lupine",
	"sainfoin",
	"triticale",
	"tritordeum",
	"vetch_and_wheat",
	"vetch_and_oat",
	"efa_vetch_and_barley",
	"efa_vetch_and_triticale",
	"vetch",
	"vineyards",
	"nursery_tree_and_shrub",
];

export default crop_type_list;